import { render } from "./AddPreventivoPage.vue?vue&type=template&id=9ac6dbe8"
import script from "./AddPreventivoPage.vue?vue&type=script&lang=js"
export * from "./AddPreventivoPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__